<!-- AI Generated Template -->
<page-header
        [icon]="icon"
        [header]="headline"
        [subHeader]="subheaderTranslation">
</page-header>
<mon-tabs
        [showSearch]="true"
        [options]="tabs"
        [(status)]="activeTab"
        (onStatus)="onStatus($event)"
        (onSearch)="onSearch($event)"
        [search]="search"
        [minSearchLength]="1"
        [showFiltersBtn]="showFilters"
        [(isFiltersOpen)]="isFiltersOpen">
    <csv-export-button [category]="monExport"></csv-export-button>
</mon-tabs>
<div class="card panel-monsido-card">
    <div class="card-body">
        <pages-table
                [currentSort]="currentSort"
                [pages]="pages"
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                (onPageSort)="onMonTableSort($event)"
                [progress]="promise"
                [(isFiltersOpen)]="isFiltersOpen"
                (onFiltersChanges)="onFiltersChanges($event)"
                [target]="'page-details-section-inventory'">
        </pages-table>
    </div>
</div>
